import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <>
    <g clipPath="url(#clip0_14267_3111)">
      <path
        d="M11.5316 5.52801C11.2714 5.26595 10.8476 5.2653 10.5865 5.52645C9.15309 6.95984 8.21801 7.89492 6.66659 9.44634L4.74358 7.52869C4.48372 7.26956 4.06308 7.26985 3.80358 7.52935C3.54382 7.7891 3.54382 8.21025 3.80358 8.47L5.95948 10.6259C6.35 11.0164 6.98317 11.0164 7.37369 10.6259L11.5299 6.46968C11.7898 6.20983 11.7905 5.78877 11.5316 5.52801ZM7.99992 1.33301C4.31992 1.33301 1.33325 4.31967 1.33325 7.99967C1.33325 11.6797 4.31992 14.6663 7.99992 14.6663C11.6799 14.6663 14.6666 11.6797 14.6666 7.99967C14.6666 4.31967 11.6799 1.33301 7.99992 1.33301Z"
        fill="#4F9F52"
      />
    </g>
    <path
      d="M11.5826 5.8024C11.3367 5.54609 10.9269 5.54561 10.6801 5.80104C9.36554 7.16167 8.50352 8.05388 7.07692 9.53046L5.31682 7.71377C5.07121 7.46026 4.66447 7.46055 4.41922 7.71439C4.18539 7.95641 4.18539 8.34018 4.41922 8.5822L6.35775 10.5886C6.75087 10.9955 7.40298 10.9955 7.7961 10.5886L11.5811 6.67106C11.815 6.42898 11.8156 6.0453 11.5826 5.8024Z"
      fill="white"
    />
  </>,
  'SuccessFilled',
  16,
  '0 0 16 16'
)
